import './styles.scss';

const Divider = () => {
  return (
    <div className="divider">
      <span className="circle"></span>
      <span className="circle"></span>
      <span className="circle"></span>
      <span className="circle"></span>
      <span className="circle"></span>
      <span className="circle"></span>
    </div>
  );
};

export default Divider;
